import { render } from "./InventoryItem.vue?vue&type=template&id=5fe81037&scoped=true&ts=true"
import script from "./InventoryItem.vue?vue&type=script&lang=ts"
export * from "./InventoryItem.vue?vue&type=script&lang=ts"

import "./InventoryItem.vue?vue&type=style&index=0&id=5fe81037&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe81037"]])

export default __exports__